import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function Modal({ children, heading, isOpen, onClose }) {
  if (!isOpen) return null;

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center overflow-y-auto p-2"
      onClick={handleBackgroundClick}
      data-testid="Modal"
    >
      <div className="bg-white rounded-lg max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="border-b border-gray-200">
          <div className="flex justify-between items-center px-8 py-2 text-gray-500">
            <h2 className="text-xl font-bold">{heading}</h2>
            <button
              onClick={onClose}
              className="w-12 h-12 flex items-center justify-center -mr-4"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>
        <div className="px-8 py-4 pb-8">{children}</div>
      </div>
    </div>,
    document.body
  );
}
